import { createSelector } from 'reselect';
import { RootState } from '../../store';

export const selectProductSortedByCategory = createSelector(
    (state: RootState) => state.productSortedByCategory,
    allTargetValue => allTargetValue.products,
);
